import { defineStore } from 'pinia'
import * as styles from '~/utils/styles'
import { darkModeKey, styleKey } from '~/utils/config'
import {getDomainOptions} from "~/utils/domain";

const domain = getDomainOptions();

export const useMainStore = defineStore('main', {
  state: () => ({
    /* Styles */
    lightBorderStyle: '',
    lightBgStyle: '',
    asideStyle: '',
    asideBrandStyle: '',
    asideMenuCloseLgStyle: '',
    asideMenuLabelStyle: '',
    asideMenuItemStyle: '',
    asideMenuItemActiveStyle: '',
    asideMenuItemInactiveStyle: '',
    asideSubmenuListStyle: '',
    navBarItemLabelStyle: '',
    navBarItemLabelHoverStyle: '',
    navBarItemLabelActiveColorStyle: '',
    navBarMenuListUpperLabelStyle: '',
    tableTrStyle: '',
    tableTrOddStyle: '',
    overlayStyle: '',

    /* User */
    userName: null,
    userEmail: null,
    userAvatar: 'https://avatars.dicebear.com/api/avataaars/example.svg?options[top][]=shortHair&options[accessoriesChance]=93',
    userPermissions: [],
    userRoles: [],
    cartProducts: [],

    /* fullScreen - fullscreen form layout (e.g. login page) */
    isFullScreen: true,

    /* Aside */
    isAsideMobileExpanded: false,
    isAsideLgActive: false,

    /* Dark mode */
    darkMode: false,

    /* Field focus with ctrl+k (to register only once) */
    isFieldFocusRegistered: false,

    /* Sample data (commonly used) */
    clients: [],
    merge_users: [],
    history: [],
    message: '',
    overlay:false,
    authorized:true,
  }),
  actions: {
    setMergeUsers (payload) {
      this.merge_users = payload
    },
    setProducts(){

      let encodedProducts = window.localStorage.getItem('CART');
      let products = null;
      if(encodedProducts != null && encodedProducts.length > 0 ){

        const decoded = atob(encodedProducts);
          const utf8Bytes = new Uint8Array(decoded.split(","));

          try{
            products = JSON.parse(new TextDecoder().decode(utf8Bytes));
          }
          catch (e)
          {
           this.destroyCart();
           return;
          }
      }

      if(products != null){
        this.cartProducts = products;
      }
      else{
        this.cartProducts = [];
      }
    },
    addProduct (payload) {
      this.setProducts();
      let newProduct = true;
      this.cartProducts.forEach((item)=>{
        if(item.cartId === payload.cartId){
          item.quantity += payload.quantity;
          newProduct = false;
        }
      })

      if(newProduct || this.cartProducts.length === 0){
        this.cartProducts.push(payload)
      }

      window.localStorage.setItem('CART', btoa(new TextEncoder().encode(JSON.stringify(this.cartProducts))))
      this.setProducts();
    },
    removeProduct (payload) {
      this.setProducts();
      let index = this.cartProducts.map((item)=>item.cartId).indexOf(payload.id);
      this.cartProducts.splice(index, 1);
      window.localStorage.setItem('CART', btoa(new TextEncoder().encode(JSON.stringify(this.cartProducts))))
      this.setProducts();
    },
    destroyCart () {
      this.cartProducts = [];
      window.localStorage.setItem('CART', btoa(new TextEncoder().encode(JSON.stringify(this.cartProducts))))
      this.setProducts();
    },
    updateProduct (payload) {
      this.setProducts();
      let index = this.cartProducts.map((item)=>item.cartId).indexOf(payload.id);
      if(index >= 0){
        this.cartProducts[index].quantity = payload.quantity;
      }
      window.localStorage.setItem('CART', btoa(new TextEncoder().encode(JSON.stringify(this.cartProducts))))
      this.setProducts();
    },
    updateProductPrice (payload) {
      this.setProducts();
      let index = this.cartProducts.map((item)=>item.cartId).indexOf(payload.id);
      if(index >= 0){
        this.cartProducts[index].price = payload.price;
      }
      window.localStorage.setItem('CART', btoa(new TextEncoder().encode(JSON.stringify(this.cartProducts))))
      this.setProducts();
    },
    setUser (payload) {
      if (payload.name) {
        this.userName = payload.name
      }
      if (payload.email) {
        this.userEmail = payload.email
      }
      if (payload.avatar) {
        this.userAvatar = payload.avatar
      }
      if (payload.permissions) {
        this.userPermissions = payload.permissions
      }
      if (payload.roles) {
        this.userRoles = payload.roles
      }
    },
    setMessage (payload) {
        this.message = payload
    },
    isAuthorization (payload) {
        this.authorized = payload
    },
    setOverlay (payload) {
        this.overlay = payload
    },

    setStyle (payload) {
      const style = styles[payload] ?? styles.basic
      if (process.client) {
        document.getElementById('admin').className = style.body
        document.documentElement.className = style.html

      if (localStorage[styleKey] !== payload) {
        localStorage.setItem(styleKey, payload)
      }
      }
      for (const key in style) {
        if (['body', 'html'].includes(key)) {
          continue
        }

        this[`${key}Style`] = style[key]
      }
    },

    asideMobileToggle (payload = null) {
      const isShow = payload !== null ? payload : !this.isAsideMobileExpanded
      if (process.client) {
      document.getElementById('__nuxt').classList[isShow ? 'add' : 'remove']('ml-60', 'lg:ml-0')

      document.documentElement.classList[isShow ? 'add' : 'remove']('m-clipped')
      }
      this.isAsideMobileExpanded = isShow
    },

    asideLgToggle (payload = null) {
      this.isAsideLgActive = payload !== null ? payload : !this.isAsideLgActive
    },

    fullScreenToggle (payload) {
      this.isFullScreen = payload
      if (process.client) {
      document.documentElement.classList[payload ? 'add' : 'remove']('full-screen')
      }
    },

    setDarkMode (payload = null) {
      const value = payload !== null ? payload : !this.darkMode
      if (process.client) {
      document.documentElement.classList[value ? 'add' : 'remove']('dark')
      localStorage.setItem(darkModeKey, value ? '1' : '0')
      }
      this.darkMode = value
    },

    fetch (sampleDataKey) {
      let data = 0;
      if(sampleDataKey === 'clients'){
         data = {"data":[{"id":19,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Howell-Hand.svg","login":"percy64","name":"Howell Hand","company":"Kiehn-Green","city":"Emelyside","progress":70,"created":"Mar 3, 2021","created_mm_dd_yyyy":"03-03-2021"},{"id":11,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Hope-Howe.svg","login":"dare.concepcion","name":"Hope Howe","company":"Nolan Inc","city":"Paristown","progress":68,"created":"Dec 1, 2021","created_mm_dd_yyyy":"12-01-2021"},{"id":32,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Nelson-Jerde.svg","login":"geovanni.kessler","name":"Nelson Jerde","company":"Nitzsche LLC","city":"Jailynbury","progress":49,"created":"May 18, 2021","created_mm_dd_yyyy":"05-18-2021"},{"id":22,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Kim-Weimann.svg","login":"macejkovic.dashawn","name":"Kim Weimann","company":"Brown-Lueilwitz","city":"New Emie","progress":38,"created":"May 4, 2021","created_mm_dd_yyyy":"05-04-2021"},{"id":34,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Justice-OReilly.svg","login":"hilpert.leora","name":"Justice O'Reilly","company":"Lakin-Muller","city":"New Kacie","progress":38,"created":"Mar 27, 2021","created_mm_dd_yyyy":"03-27-2021"},{"id":48,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Adrienne-Mayer-III.svg","login":"ferry.sophia","name":"Adrienne Mayer III","company":"Kozey, McLaughlin and Kuhn","city":"Howardbury","progress":39,"created":"Mar 29, 2021","created_mm_dd_yyyy":"03-29-2021"},{"id":20,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Mr.-Julien-Ebert.svg","login":"gokuneva","name":"Mr. Julien Ebert","company":"Cormier LLC","city":"South Serenaburgh","progress":29,"created":"Jun 25, 2021","created_mm_dd_yyyy":"06-25-2021"},{"id":47,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Lenna-Smitham.svg","login":"paolo.walter","name":"Lenna Smitham","company":"King Inc","city":"McCulloughfort","progress":59,"created":"Oct 8, 2021","created_mm_dd_yyyy":"10-08-2021"},{"id":24,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Travis-Davis.svg","login":"lkessler","name":"Travis Davis","company":"Leannon and Sons","city":"West Frankton","progress":52,"created":"Oct 20, 2021","created_mm_dd_yyyy":"10-20-2021"},{"id":49,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Prof.-Esteban-Steuber.svg","login":"shana.lang","name":"Prof. Esteban Steuber","company":"Langosh-Ernser","city":"East Sedrick","progress":34,"created":"May 16, 2021","created_mm_dd_yyyy":"05-16-2021"},{"id":36,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Russell-Goodwin-V.svg","login":"jewel07","name":"Russell Goodwin V","company":"Nolan-Stracke","city":"Williamsonmouth","progress":55,"created":"Apr 22, 2021","created_mm_dd_yyyy":"04-22-2021"},{"id":33,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Ms.-Cassidy-Wiegand-DVM.svg","login":"burnice.okuneva","name":"Ms. Cassidy Wiegand DVM","company":"Kuhlman-Hahn","city":"New Ruthiehaven","progress":76,"created":"Sep 16, 2021","created_mm_dd_yyyy":"09-16-2021"},{"id":44,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Mr.-Watson-Brakus-PhD.svg","login":"oconnell.juanita","name":"Mr. Watson Brakus PhD","company":"Osinski, Bins and Kuhn","city":"Lake Gloria","progress":58,"created":"Jun 22, 2021","created_mm_dd_yyyy":"06-22-2021"},{"id":46,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Mr.-Garrison-Friesen-V.svg","login":"vgutmann","name":"Mr. Garrison Friesen V","company":"VonRueden, Rippin and Pfeffer","city":"Port Cieloport","progress":39,"created":"Oct 19, 2021","created_mm_dd_yyyy":"10-19-2021"},{"id":14,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Ms.-Sister-Morar.svg","login":"veum.lucio","name":"Ms. Sister Morar","company":"Gusikowski, Altenwerth and Abbott","city":"Lake Macville","progress":34,"created":"Jun 11, 2021","created_mm_dd_yyyy":"06-11-2021"},{"id":40,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Ms.-Laisha-Reinger.svg","login":"edietrich","name":"Ms. Laisha Reinger","company":"Boehm PLC","city":"West Alexiemouth","progress":73,"created":"Nov 2, 2021","created_mm_dd_yyyy":"11-02-2021"},{"id":5,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Cameron-Lind.svg","login":"mose44","name":"Cameron Lind","company":"Tremblay, Padberg and Pouros","city":"Naderview","progress":59,"created":"Sep 14, 2021","created_mm_dd_yyyy":"09-14-2021"},{"id":43,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Sarai-Little.svg","login":"rau.abelardo","name":"Sarai Little","company":"Deckow LLC","city":"Jeanieborough","progress":49,"created":"Jun 13, 2021","created_mm_dd_yyyy":"06-13-2021"},{"id":2,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Shyann-Kautzer.svg","login":"imurazik","name":"Shyann Kautzer","company":"Osinski, Boehm and Kihn","city":"New Alvera","progress":41,"created":"Feb 15, 2021","created_mm_dd_yyyy":"02-15-2021"},{"id":15,"avatar":"https:\/\/avatars.dicebear.com\/v2\/gridy\/Lorna-Christiansen.svg","login":"annalise97","name":"Lorna Christiansen","company":"Altenwerth-Friesen","city":"Port Elbertland","progress":36,"created":"Mar 9, 2021","created_mm_dd_yyyy":"03-09-2021"}]} ;

      }
      else{
       data = {"data":[{"amount":375.53,"account":"45721474","name":"Home Loan Account","date":"3 days ago","type":"deposit","business":"Turcotte"},{"amount":470.26,"account":"94486537","name":"Savings Account","date":"3 days ago","type":"payment","business":"Murazik - Graham"},{"amount":971.34,"account":"63189893","name":"Checking Account","date":"5 days ago","type":"invoice","business":"Fahey - Keebler"},{"amount":374.63,"account":"74828780","name":"Auto Loan Account","date":"7 days ago","type":"withdrawal","business":"Collier - Hintz"}]}
      }

      // http
      //   .get(`/data-sources/${sampleDataKey}.json`)
      //   .then(r => {
          if (data && data.data) {
            this[sampleDataKey] = data.data
          }
      //   })
      //   .catch(error => {
      //     alert(error.message)
      //   })
    }
  }
})

export const useDomainStore = defineStore('domain', {
  state: () => ({
    title:domain.title,
    brother_title:domain.brother_title,
    brother_link:domain.brother_link,
    privacy:domain.privacy,
    site_map:domain.site_map,
    logo_big:domain.logo_big,
    logo_small:domain.logo_small,
    logo_white:domain.logo_white,
    menu_title:domain.menu_title,
    facebook:domain.facebook,
    instagram:domain.instagram,
    youtube:domain.youtube,
    twitter:domain.twitter,
    gtag_src:domain.gtag_src,
    gtag_script:domain.gtag_script,
  }),
})
